export default __webpack_public_path__ + "static/media/google.5261a003.svg";